import * as React from 'react';
import { HeaderTitle } from '@/components/ui/about/HeaderTitle';
import { HeaderDescription } from '@/components/ui/about/HeaderDescription';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { cn } from '@/lib/utils';

import BackgroundImageContainer from '../ui/BackgroundImageContainer';

interface AboutHeaderProps {
	backgroundImage?: string; // Optional prop for background image URL
}

const AboutHeader: React.FC<AboutHeaderProps> = ({ backgroundImage }) => {
	const { isBannerActive } = useSiteSettings();
	const backgroundImageUrl = backgroundImage || '/contact-banner.svg';

	return (
		<section className=''>
			<BackgroundImageContainer
				imageUrl={backgroundImageUrl}
				overlayOpacity={0.5}
				className={cn(
					'flex flex-col items-center px-16 w-full max-md:px-5 max-md:max-w-full',
					isBannerActive ? 'pt-22' : 'pt-20',
				)}
			>
				<div className='mb-0 w-full max-w-[1215px] max-md:mb-2.5 max-md:max-w-full md:px-8 px-4'>
					<div className='flex gap-5 max-md:flex-col py-8 md:px-2'>
						<div className='w-[65%] max-md:ml-0 max-md:w-full py-8'>
							<div className='mr-0 font-bold text-neutral-100 max-md:max-w-full'>
								<HeaderTitle />
								<HeaderDescription />
							</div>
						</div>
					</div>
				</div>
			</BackgroundImageContainer>
		</section>
	);
};

export default AboutHeader;
